import './style/newslettersPage.scss';

import React, {MouseEventHandler} from 'react';
import Document from '../../../models/documentModel';
import classNames from 'classnames';
import EditableHeader from '../../editor/editableHeader';
import EditablePar from '../../editor/editablePar';

interface Props {
    onDownloadNewsletter: (newsletter: Document) => MouseEventHandler;
    newsletters: Array<Document>;
    loading: boolean;
    downloading: boolean;
}

export default function NewslettersPage(props: Props) {
    const {loading, onDownloadNewsletter, newsletters, downloading} = props;

    function renderNewsletter(newsletter: Document, index: number) {
        return (
            <label key={index} className={classNames('default-link ul click newsletter', loading && 'loading')}
                   onClick={loading ? undefined : onDownloadNewsletter(newsletter)}
                   title='Downloaden'>{newsletter.label}</label>
        );
    }

    function renderDummyNewsletters() {
        const dummies: Array<Document> = [
            new Document({file_name: 'a'}),
            new Document({file_name: 'a'}),
            new Document({file_name: 'a'}),
            new Document({file_name: 'a'}),
            new Document({file_name: 'a'})
        ];
        return dummies.map(renderNewsletter);
    }

    return (
        <div className='default-page newsletters-page'>
            <EditableHeader textKey='newsletter-head-1' className='page-title'/>
            <section className='section'>
                <EditableHeader textKey='newsletter-head-2' className='section-title' headerType='h2'/>
                <EditablePar textKey='newsletter-text-1' className='section-par'/>
                <div className='newsletters-container'>
                    {loading ? renderDummyNewsletters() : newsletters.map(renderNewsletter)}
                </div>
            </section>
        </div>
    );
}

NewslettersPage.displayName = 'NewslettersPage';